import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span class=\"{{this.tagClass}}\">\n  {{this.label}}\n</span>",{ moduleName: "sh-www/components/lsg/lsg-badge.hbs" })